import { render, staticRenderFns } from "./LogisticsTracking.vue?vue&type=template&id=a93c23fa&scoped=true"
import script from "./LogisticsTracking.vue?vue&type=script&lang=js"
export * from "./LogisticsTracking.vue?vue&type=script&lang=js"
import style0 from "./LogisticsTracking.vue?vue&type=style&index=0&id=a93c23fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93c23fa",
  null
  
)

export default component.exports